import axiosClient from './axiosClient';
import { TicketStatusModel } from '../Models/ticketStatusModel';

const ticketStatusService = {
  getAll: () => {
    return axiosClient.get('/TicketStatus')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /TicketStatus returned 404. Falling back to GET /ticket-statuses...");
          return axiosClient.get('/ticket-statuses');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(TicketStatusModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (id) => {
    return axiosClient.get(`/TicketStatus/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /TicketStatus/${id} returned 404. Falling back to GET /ticket-statuses/${id}...`);
          return axiosClient.get(`/ticket-statuses/${id}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketStatusModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = TicketStatusModel.toBackend(payload);
    body.statusId = 0;

    return axiosClient.post('/TicketStatus', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketStatus returned 404. Falling back to POST /ticket-statuses...");
          return axiosClient.post('/ticket-statuses', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketStatusModel.toFrontend(raw),
        };
      });
  },

  update: (id, payload) => {
    const body = TicketStatusModel.toBackend({ ...payload, statusID: id });

    return axiosClient.put('/TicketStatus', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /TicketStatus returned 404. Falling back to PUT /ticket-statuses...");
          return axiosClient.put('/ticket-statuses', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: TicketStatusModel.toFrontend(raw),
        };
      });
  },

  remove: (id) => {
    return axiosClient.delete(`/TicketStatus/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketStatus/${id} returned 404. Falling back to DELETE /ticket-statuses/${id}...`);
          return axiosClient.delete(`/ticket-statuses/${id}`);
        }
        return Promise.reject(err);
      });
  },
};

export default ticketStatusService;
